export default __webpack_public_path__ + "static/media/s.430d67a4.jpg";